import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../configurations/config";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";

const ActionFormatter = ({ weekStart }) => (
	<Link
		to={{
			pathname:
				`${Routes.MyTimeSheetsStatus}?week=` +
				moment(weekStart).format(APIDateFormat),
			state: {
				weekStartDate: weekStart,
			},
		}}
		target="_blank"
	>
		<button className="btnStyle" title="View Detail">
			<FontAwesomeIcon
				id="edit"
				className="hoverEffect"
				icon={faEye}
				size="1x"
			/>
		</button>
	</Link>
);

export default ActionFormatter;
